const KEY_CHECKED = 'checkDialog';
const VALUE_YES = 'yes';
const VALUE_NO = 'no';

function useCheckNotificationDialog(): any[] {
  if (!window?.localStorage) return [];

  const checkedFromSource = Boolean(window.localStorage.getItem(KEY_CHECKED) === VALUE_YES);

  return [checkedFromSource, setCheckNotificationDialog];
}

function setCheckNotificationDialog(checked: boolean) {
  if (!window?.localStorage) return;
  window.localStorage.setItem(KEY_CHECKED, checked ? VALUE_YES : VALUE_NO);
}

export default useCheckNotificationDialog;
